import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { ButtonComponent } from '../../components/button/button.component';
import { RouterLink } from '@angular/router';
import { SelectInputComponent } from '../../components/select-input/select-input.component';

@Component({
  selector: 'app-division-form-page',
  imports: [HeaderComponent, TextInputComponent, ButtonComponent, RouterLink, SelectInputComponent],
  templateUrl: './division-form-page.component.html',
})
export class DivisionFormPageComponent {

}
